import { CheckBox } from "risa-oasis-ui_v2";
import { DocumentsStoreedInLocalStorage } from "../../../../data-model/docsStorageInLocalStorage";

interface MedicineSelectionProps {
  docMetaData: DocumentsStoreedInLocalStorage[];
  selectedMedicines: string[];
  onMedicineSelection: (medicineName: string, isChecked: boolean) => void;
  onCheckBoxEvent: (medicineName: string, isChecked: boolean) => void;
}

const MedicineSelection = ({
  docMetaData,
  selectedMedicines,
  onMedicineSelection,
  onCheckBoxEvent,
}: MedicineSelectionProps) => {
  return (
    <div className="text-tiny">
      Select Drugs for which this document is valid
      <div className="mt-2 flex flex-col gap-2">
        {docMetaData?.map((doc) => {
          const id = doc?.jcodeIdentifier ?? "";
          const isChecked = selectedMedicines.includes(id);
          return (
            <CheckBox
              key={`${id}-${isChecked}`}
              label={doc?.jcodeDescription ?? ""}
              id={id}
              onCheckBoxValueChange={(data) => {
                onMedicineSelection(id, data.value);
                onCheckBoxEvent(id, data.value);
              }}
              defaultValue={isChecked}
              isDisabled={doc?.isDocPresent ?? false}
            />
          );
        })}
      </div>
    </div>
  );
};

export default MedicineSelection;
